import { SeaReferenceTypesDTO } from "entities/shared/seaCard.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

export type SeaScacQueryParam = string;

/** Query params for Qubictron tracking/v1/ocean (see API docs). */
export type SeaQueryParams = {
  reference_number: SearchReferenceDTO;
  carrier_code?: Nullable<SeaScacQueryParam>;
  reference_type?: Nullable<"bl" | "booking" | "container" | ValueOf<typeof SeaReferenceTypesDTO>>;
  route_details?: Nullable<boolean>;
  signal?: AbortSignal;
};

/** Map UI/legacy types (CT/BL/BK) to Qubictron API reference_type. */
export const mapSeaReferenceTypeToApi = (type?: string | null): "bl" | "booking" | "container" | undefined => {
  if (!type) return undefined;

  const normalized = type.trim().toLowerCase();
  if (normalized === "bl" || normalized === "booking" || normalized === "container") {
    return normalized;
  }

  const upper = type.trim().toUpperCase();
  if (upper === SeaReferenceTypesDTO.BL || upper === "BILL_OF_LADING") return "bl";
  if (upper === SeaReferenceTypesDTO.BK || upper === "BOOKING") return "booking";
  if (upper === SeaReferenceTypesDTO.CT || upper === "CONTAINER") return "container";

  return undefined;
};
